// extracted by mini-css-extract-plugin
module.exports = {"joinBlock":"PremiumBlock_joinBlock__nennd","joinButton":"PremiumBlock_joinButton__F5s0L","joinLink":"PremiumBlock_joinLink__sf2G9"};